<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="foreword">
<h1>Foreword</h1>
<p>This is my fifth book on China but is a little different from the others. <em>A Traveller in China</em>, <em>A Traveller in Fujian Province, China</em> and <em>Journey to Beijing</em> are all travelogues although the last mentioned has a twist. <em>China—Behind the Mask</em> is different, being an attempt to understand China, which I believe is essential in today’s world.</p>
<p>This current book, <em>Teaching in Fuzhou,</em> is—as the title suggests—concerned with my experiences as a teacher in Fuzhou, mainly at Anglo-Chinese College, situated in Fuzhou, capital of Fujian Province, which lies opposite Taiwan. The cover photograph shows the sun in a copper coloured sky setting over the Min Jiang, with Zhong Zhou Dao, an island in the river, on the left.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?00fdf84f